import type React from 'react';

import * as styles from './styles';
import classnames from 'classnames';

import {
  Rules,
  type ValidationResponse,
} from '@cobliteam/password-strength-meter';

import {
  Caption,
  CheckIcon,
  DescriptionListDefault,
} from '@cobliteam/base-components';

export interface PasswordRulesProps {
  validationResponse?: ValidationResponse;
  darkTheme?: boolean;
  disableSafePasswordCaption?: boolean;
}

const ruleStyle = (
  rule: Rules,
  validationResponse?: ValidationResponse,
  darkTheme?: boolean
) => {
  if (validationResponse?.rules[rule].valid) {
    return classnames(styles.rule, { darkTheme }, { fulfilled: true });
  }
  return classnames(styles.rule, { darkTheme }, { fulfilled: false });
};

export const PasswordRules: React.FC<PasswordRulesProps> = (props) => {
  const { validationResponse, darkTheme, disableSafePasswordCaption } = props;
  const passwordValid = validationResponse?.isPasswordValid;
  if (passwordValid) {
    if (disableSafePasswordCaption) {
      return <></>;
    }
    return (
      <div className={styles.safePasswordContainer}>
        <CheckIcon className={styles.checkIcon} />
        <Caption className={styles.safePasswordCaption}>
          Sua senha é segura!
        </Caption>
      </div>
    );
  }
  return (
    <div className={styles.rulesContainer}>
      <DescriptionListDefault
        className={ruleStyle(Rules.uppercase, validationResponse, darkTheme)}
      >
        Uma letra maiúscula
      </DescriptionListDefault>
      <DescriptionListDefault
        className={ruleStyle(Rules.specialChar, validationResponse, darkTheme)}
      >
        Um caractere especial
      </DescriptionListDefault>
      <DescriptionListDefault
        className={ruleStyle(Rules.lowercase, validationResponse, darkTheme)}
      >
        Uma letra minúscula
      </DescriptionListDefault>
      <DescriptionListDefault
        className={ruleStyle(Rules.minLength, validationResponse, darkTheme)}
      >
        Mínimo de 8 caracteres
      </DescriptionListDefault>
      <DescriptionListDefault
        className={ruleStyle(Rules.maxLength, validationResponse, darkTheme)}
      >
        Máximo de 20 caracteres
      </DescriptionListDefault>
      <DescriptionListDefault
        className={ruleStyle(Rules.digit, validationResponse, darkTheme)}
      >
        Um número
      </DescriptionListDefault>
    </div>
  );
};
